import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import { CommonService } from "@shared/services/common.service";
import storageService from "@shared/storage/storageService";
import { DatePipe } from "@angular/common";
import * as XLSX from "xlsx";

@Component({
  selector: 'app-ca-annual-evaluation',
  templateUrl: './ca-annual-evaluation.component.html',
  styleUrls: ['./ca-annual-evaluation.component.scss']
})
export class CaAnnualEvaluationComponent implements OnInit {
  currentUser: any;
  lang: any;
  data: any;
  tempData: any;
  criteriaData: any;
  totalRecords: any;
  visible: boolean;
  showSpinner: boolean;
  ratingData: number;
  search: any;
  accountantName: any[];
  filterFeedback: any;
  filterRating: any;
  isFilterEnable: any;
  cols: { field: string; header: string; sortable: boolean }[];
  exportData: any;
  fileName = "Venaqi.xlsx";
  feedbackTitleName: any[];

  constructor(
    private broadcast: BroadCastServiceService,
    private commonService: CommonService,
    private router: Router,
    private auth: ApiCall
  ) {}

  ngOnInit(): void {
    this.broadcast.sendMessage("chief-account"),
      (this.currentUser = JSON.parse(localStorage.getItem("currentUser")));
    this.lang = storageService.getItem("language");
    this.commonService.isComponent = "ca-annual-evaluation";

    this.getAllFeedbacks();

    this.broadcast.getMessage().subscribe((message) => {
      if (message == "getAllFeedbacks") {
        this.getAllFeedbacks();
        this.refresh();
      }
    });

    this.broadcast.getEvaluationFeedback().subscribe((message) => {
      this.getAllFeedbacks();
      this.disableEvaluationFeedback();
    });

    this.cols = [
      { field: "Accountant Name", header: "ACC_NAME", sortable: false },
      { field: "title", header: "TITLE", sortable: false },
      { field: "Import PDF", header: "IMPORT_PDF", sortable: false },
      { field: "Date", header: "DATE", sortable: false },
      { field: "Speciality", header: "SPECIALITY", sortable: false },
      { field: "department", header: "DEPARTMENT", sortable: false },
    ];
  }
  refresh() {
    this.broadcast.sendMessage("chief-account"),
      (this.currentUser = JSON.parse(localStorage.getItem("currentUser")));
    this.lang = storageService.getItem("language");
    this.commonService.isComponent = "ca-annual-evaluation";
  }

  annualEvaCriteria() {
    this.router.navigate(["chiefaccountant/ca-criteria-employee-evaluation", true]);
  }

  getAllFeedbacks() {
    try {
      this.accountantName = [];
      this.feedbackTitleName = []
      let type = 2;
      this.auth.getPeriodicFeedback(type, false).subscribe((response: any) => {
        if (response.status === "SUCCESS") {
          this.data = response.data;
          this.tempData = this.data;
          this.totalRecords = response.data.totalRecords;
          for (let item of this.data) {
            if (
              !this.accountantName
                .map((accountant) => accountant.userId)
                .includes(item.userId)
            ) {
              this.accountantName.push(item);
            }
            if(item.title && !this.feedbackTitleName.includes(item.title)){
              this.feedbackTitleName.push(item.title);
            }

          }
        } else {
          this.ratingData = 0;
          console.error(
            "Error occurred while getting all feedbacks, ",
            response.message
          );
        }
        this.visible = true;
        this.showSpinner = false;
      });
    } catch (error) {
      console.log("Error occurred while getting all feedbacks, ", error);
    }
  }

  exportToExcel(): void {
    if (this.exportData) {
      const data = this.exportData.map((c) => c.tempList);
      const ws = XLSX.utils.json_to_sheet(data);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, this.fileName);
    }
  }

  onChange(filter) {
    this.isFilterEnable = true;
    this.broadcast.employeeFeedDropChanges(filter);
  }


  onTitleChange(filter){
    this.isFilterEnable =  true;
    this.broadcast.titleDropChanges(filter)
  }
  filterFeebackData(event) {}

  getData(event) {
    this.tempData = event.data;
  }

  getExportData(event) {
    this.exportData = event.data;
    this.prepareDataForExport(this.exportData);
  }
  clearFilter() {
    this.broadcast.employeeFeedDropChanges("");
    this.isFilterEnable = false;
    this.filterFeedback = undefined;
  }

  prepareDataForExport(data) {
    var datePipe = new DatePipe("en-US");
    data?.forEach((element, i) => {
      let temp1 = JSON.stringify(element.evalFeedbackDetails);
      temp1 = JSON.parse(temp1);
      this.exportData[i].evalFeedbackDetails = temp1;
      this.exportData[i].evalFeedbackDetails.splice(-1);
      let keys = [];
      element.evalFeedbackDetails.forEach((ele) => {
        keys.push(ele.criteriaName);
      });
      let tempList = [];
      let temp = [];
      if (this.lang == "en") {
        temp.push({
          status: element.feedbackDisable ? "Close" : "In Progress",
        });
        temp.push({ Name: element.accName });
        temp.push({
          Date: datePipe.transform(element.createdDate, "dd/MM/yyyy"),
        });
        temp.push({ Speciality: element.user.grade });
        temp.push({ department: element.user.department });
      } else {
        temp.push({
          status: element.feedbackDisable ? "Close" : "In Progress",
        });
        temp.push({ Nom: element.accName });
        temp.push({
          Date: datePipe.transform(element.createdDate, "dd/MM/yyyy"),
        });
        temp.push({ spécialité: element.specialityName });
        temp.push({ department: element.department });
      }

      tempList = temp;
      this.exportData[i]["tempList"] = Object.assign({}, ...tempList);
    });
    this.exportData?.sort(
      (a, b) =>
        new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );
  }

  disableEvaluationFeedback() {
    this.auth.disableEvalautionFeedback(456789).subscribe((res: any) => {
      if (res.status === "SUCCESS") {
      }
    });
  }
}
